import styled from 'styled-components'

export const Content = styled.img`
  display: block;
  margin: 0;
`
